export enum AccountStatusEnum {
  Enabled = 1,
  ClosePositionOnly = 2,
  Disabled = 3,
  NULL_VALUE = 255,
}
